import NetworkError from "../http/networkError";
import { ErrorType } from "../http/types";

export default class CybwellError extends NetworkError {
  public cybwellStatus: string;

  /**
   * Constructs a cybwell error.
   *
   * @param message The error message.
   * @param cybwellStatus The internal cybwell error message.
   */
  constructor(message: string, cybwellStatus?: string) {
    super(message);
    this.cybwellStatus = cybwellStatus;
    this.type = ErrorType.CYBWELL;
    if (
      "captureStackTrace" in Error &&
      typeof Error.captureStackTrace === "function"
    ) {
      Error.captureStackTrace(this, CybwellError);
    } else if (Object.prototype.hasOwnProperty.call(Error, "stack")) {
      this.stack = new Error().stack;
    }
  }
}
